const COPIED_STATE_DURATION = 2000;

document.querySelectorAll('[data-copy]').forEach(item => {
	item.addEventListener('click', handlerCopyValue);
});

async function handlerCopyValue(event) {
	let node = event.currentTarget;

	// Состояние "Скопировано" показываем только если копирование правда прошло,
	// иначе пользователь уверен, что почта в буфере, а её там нет
	if (!await copyText(node.dataset.copy)) return;

	node.classList.add('copied');

	clearTimeout(node.timer);
	node.timer = setTimeout(() => node.classList.remove('copied'), COPIED_STATE_DURATION);
}

/**
 * @param {string} value
 * @returns {Promise<boolean>} удалось ли скопировать
 */
async function copyText(value) {
	if (!value) return false;

	try {
		// await внутри try ловит и отклонённый промис, и TypeError:
		// в незащищённом контексте navigator.clipboard === undefined
		await navigator.clipboard.writeText(value);
		return true;
	} catch (error) {
		console.error('Ошибка при копировании в буфер обмена:', error);
		return false;
	}
}
